/* eslint-disable react/no-unescaped-entities */
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H4, H5 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
import Link from 'next/link';

export default function Page() {
  return (
    <article>
      <MetaTags title="Independent Publisher Agreement - EnergyPal" noindex />
      <CenteredContentSection>
        <H4>Independent Publisher Agreement.</H4>
        <p>
          THIS INDEPENDENT PUBLISHER AGREEMENT (THE “AGREEMENT”) IS ENTERED
          INTO, AS OF THE DATE OF YOUR ACCEPTANCE, BY AND BETWEEN ENERGYGEEKS
          CORPORATION dba ENERGYPAL (“ENERGYPAL”) AND YOU (THE “PUBLISHER”). BY
          AGREEING TO THE TERMS SET FORTH HEREIN YOU ATTEST THAT YOU HAVE THE
          AUTHORITY TO MAKE THIS AGREEMENT ON BEHALF OF PUBLISHER. ACCORDINGLY,
          ENERGYPAL AND PUBLISHER JOINTLY AGREE TO THE FOLLOWING TERMS AND
          CONDITIONS:
        </p>
        <H5>1. Lead Generation.</H5>
        <ol type="a">
          <li>
            Provisioning of Leads. Pursuant to the terms of this Agreement,
            Publisher agrees to sell Leads and Lead Data to ENERGYPAL that have
            been generated through Publisher Materials only (the "Lead
            Services").
          </li>
          <li>
            Lead Exclusivity. Publisher may provide the same or similar services
            as the Lead Services to third parties. Notwithstanding the
            foregoing, unless otherwise set forth in a specific Publisher
            campaign Insertion Order and in ENERGYPAL systems, (i) all Contract
            Leads shall be exclusive to ENERGYPAL and neither Publisher nor its
            agents shall provide any Contract Leads to any other third party;
            and (ii) neither Publisher nor any Subcontractor shall contact any
            Contract Lead for any offer or service inquiry for at least one
            hundred and eighty (180) days from the date such Contract Lead is
            submitted to ENERGYPAL.
          </li>
          <li>
            Lead Quality Control. ENERGYPAL shall retain the right to revise,
            alter or correct any of the information contained in any Contract
            Lead for quality control and sales purposes. ENERGYPAL shall retain
            the right to conduct quality control on any Contract Lead, reject
            any Contract Lead for quality control purposes, or suspend the sale
            of Contract Leads for quality control purposes at any time.
          </li>
        </ol>
        <H5>2. Payable Amount; Payment.</H5>
        <ol type="a">
          <li>
            Payable Amount. For each Contract Lead submitted to ENERGYPAL by
            Publisher pursuant to this Agreement, which further signs a customer
            agreement to purchase products or services offered by ENERGYPAL,
            Publisher shall earn a fee, upon the Contract Lead reaching specific
            predefined milestones, to be payable by ENERGYPAL. The milestones
            and amount per Contract Lead shall be set in the Publisher Account,
            and may be updated from time to time by mutual written agreement.
            The “Payable Amount” is calculated as (i) the total Contract Leads
            achieving the predefined milestones net of Disqualified,
            cancellations and terminations of customer agreements, multiplied by
            (ii) the amount per Contract Lead.
          </li>
          <li>
            Notwithstanding the foregoing, unless otherwise set forth in a
            specific Publisher campaign Insertion Order and in ENERGYPAL
            systems, ENERGYPAL shall pay only for non-duplicative Leads
            generated and submitted to ENERGYPAL by the Publisher pursuant to
            this Agreement. Furthermore, ENERGYPAL shall not pay for any Lead
            that constitutes a Disqualified Lead during the qualification and
            sales process or any Leads generated not in compliance with
            applicable Law. In the event of a dispute with respect to the
            number, pricing and quality of Leads received by ENERGYPAL,
            ENERGYPAL’s tracking and computer systems shall control.
          </li>
          <li>
            Payment. ENERGYPAL shall initiate payment of the applicable monthly
            Lead Payable Amount to Publisher net thirty (30) days from the end
            of each month during the term of this Agreement unless another
            payment date is agreed to in writing and updated in the Publisher
            Account settings.
          </li>
        </ol>
        <H5>3. Lead Submission</H5>
        <p>
          Publisher shall submit all Contract Leads to ENERGYPAL via web hook,
          data post and tracking links to ENERGYPAL forms approved and tested in
          advance by ENERGYPAL and in accordance with this Agreement.
        </p>
        <H5>4. Publisher Obligations.</H5>
        <ol type="a">
          <li>
            Compliance
            <ol>
              <li>
                <span className="underline">General Compliance</span>. Publisher
                and its Subcontractors (including any affiliate networks, if
                applicable) shall comply with all applicable U.S. laws in
                connection with the Lead Services and all Publisher’s lead
                generation activities and obligations under this Agreement,
                including without limitation, applicable privacy and data
                security laws (including, without limitation, the right to share
                Lead contact information with third-parties), laws governing
                registration of fictitious names, provincial, state, and federal
                marketing and advertising laws, the Consumer Protection Act,
                CAN-SPAM Act and any applicable provincial and state spam laws,
                CALSSA Consumer Protection Rules, the U.S. Federal Trade
                Commission’s Amended Telemarketing Sales Rule ("TSR"), and the
                Telephone Consumer Protection Act of 1991 ("TCPA"), and
                California Consumer Privacy Act at all times (collectively, the
                "Consumer Protection Laws"). Furthermore, Publisher and its
                Subcontractors shall comply with ENERGYPAL's Marketing and
                Advertising <Link href="/advertising">Compliance Policy</Link>,
                as set forth in Publisher Account, in connection with fulfilling
                Publisher’s obligations under this Agreement.
              </li>
              <li>
                <span className="underline">Publisher Materials</span>.
                Publisher agrees (i) that Publisher shall be solely liable and
                responsible for all Publisher Materials used in connection with
                this Agreement and the Lead Services, (ii) that all Publisher
                Materials shall comply with applicable law at all times,
                including without limitation, Consumer Protection Laws, and
                (iii) that Publisher shall not make any material misstatements
                or omissions in any Publisher Materials as it relates to the
                applicable offering. Publisher shall be solely responsible for
                ensuring that all objective claims (express or implied)
                contained in any Publisher Materials are (i) true and (ii)
                substantiated through internal and/or external data sources and
                evidence prior to dissemination. Upon two (2) days written
                request by ENERGYPAL, Publisher shall provide ENERGYPAL with
                copies of all Publisher Materials used to generate Contract
                Leads under this Agreement, including, without limitation, any
                marketing materials used by any Subcontractors (as defined
                below), if applicable.
              </li>
              <li>
                <span className="underline">TCPA Compliance</span>. Publisher
                shall require and ensure that all Contract Leads submitted under
                this Agreement expressly consent to the submission of their
                information via a process that (i) is compliant with applicable
                federal, provincial, state and local laws (including, without
                limitation, applicable Consumer Protection Laws and the ESIGN
                Act) and (ii) allows any Contract Lead (including any personally
                identifiable information associated with such Contract Lead) to
                be lawfully shared with ENERGYPAL for purposes of (x)
                ENERGYPAL’s Commercial Lead Use and (y) ENERGYPAL re-selling or
                transferring the Contract Lead to ENERGYPAL’s clients for their
                Commercial Lead Use. For the avoidance of doubt and without
                limiting anything in this Section 4, Publisher shall be
                responsible for (i) ensuring that all prior express written
                consent language on any Publisher Materials complies with the
                TCPA and TSR (as well as any applicable provincial and state
                laws), and (ii) obtaining prior express written consent, as
                defined by the TCPA and TSR (and as may be modified by
                applicable provincial and state laws), from all Contract Leads
                to be contacted by ENERGYPAL and ENERGYPAL’s clients, as the
                case may be, using an automatic telephone dialing system even if
                such Contract Lead’s phone number is on a federal, provincial or
                state “Do Not Call” list. Such consent shall have been obtained
                prior to submission of any Contract Lead to ENERGYPAL without
                any prior revocation. Publisher shall provide at least three (3)
                days prior written notice to ENERGYPAL in the event Publisher
                revises or modifies any privacy policy or opt in statement in
                connection with any Publisher Materials.
              </li>
              <li>
                <span className="underline">Opt In/Consent Record Keeping</span>
                . Unless otherwise set forth in a Publisher Agreement, Publisher
                shall use an approved LeadiD tracking code application (i.e.,
                Journaya, TrustedForm) for TCPA compliance purposes on all of
                its landing pages or websites where Leads are generated and any
                conversion pages where Leads are generated. Publisher must
                submit each Lead to ENERGYPAL with a unique and valid LeadiD
                tracking code. Any Leads that do not contain a LeadiD tracking
                code will be rejected and Publisher will not receive any money
                for such Leads. For compliance purposes only, Publisher grants
                to ENERGYPAL a fully-paid and non-revocable licenses to store
                and use any creatives, graphics or other Publisher Materials
                captured as a result of LeadiD (or other third party services in
                connection with this Agreement. Notwithstanding the foregoing,
                Publisher shall provide evidence of consumer opt in or consent
                to be contacted pursuant to this Agreement for any Contract
                Lead, in a form satisfactory to ENERGYPAL, to ENERGYPAL upon
                three (3) days written notice to Publisher. Such evidence shall
                include, but not be limited to, web addresses and websites where
                the Contract Lead’s consent was obtained, date and time stamps
                on such websites, IP addresses of any Contract Leads, copies of
                any opt in statements seen by Contract Leads, or voice
                recordings of Contract Lead consent. Publisher shall retain such
                evidence for at least five (5) years from the date the Contract
                Lead opted in. To the extent that ENERGYPAL permits use of
                another third party TCPA compliance service in lieu of LeadiD,
                the provisions of this section shall continue to apply.
              </li>
              <li>
                <span className="underline">Prohibited Activity</span>. The
                Publisher Materials shall not contain any (i) pornographic or
                offensive material, (ii) software trading, hacking or phreaking
                content, (iii) illegal music reproduction, downloads or content,
                (iv) content that infringes on any copyright, patent, trademark
                or service mark, trade secret rights or any other personal,
                moral, contract, property or privacy right of any third party,
                (v) any content that is not properly substantiated pursuant to
                applicable provincial, state and federal marketing and
                advertising laws or (vi) any other illegal content. Publisher
                shall not distribute any spyware, adware, trojans, viruses,
                worms, spybots, keyloggers or any other form of malware through
                any Publisher Materials. Publisher shall not (i) engage in the
                practice of search engine “spamming” (i.e., the inappropriate
                use of search engine optimization tactics such as doorway pages
                or cloaking); or (ii) provide visitors with any incentive or
                compensation on the Publisher Materials with respect to the
                submission of any Lead.
              </li>
              <li>
                <span className="underline"></span>
              </li>
            </ol>
          </li>
          <li>
            <em>Copying</em>. Publisher shall not copy, mimick, recreate or
            distribute any advertisements (including, without limitation, text
            ads, image ads, email creatives, websites, online landing pages)
            created, promoted, or owned by ENERGYPAL without the prior written
            consent of ENERGYPAL.
          </li>
          <li>
            <em>Call Center</em>. Publisher shall not (i) use a call center or
            engage in any inbound or outbound telemarketing in connection with
            the Lead Services or the generation or qualification of the Leads or
            (ii) submit any Contract Lead to ENERGYPAL that has been generated
            or qualified via outbound or inbound telemarketing or call service.
            For the avoidance of doubt, neither Publisher nor any Subcontractor
            shall initiate any outbound telephone calls or send any texts,
            faxes, pre-recorded messages, or automated messages to any
            individual under this Agreement.
          </li>
          <li>
            <em>Diligence</em>. Publisher agrees to provide ENERGYPAL with any
            materials related to Publisher’s or any Subcontractor’s compliance
            with applicable Law in connection with their performance under this
            Agreement, as reasonably requested by ENERGYPAL from time to time.
          </li>
          <li>
            <em>Insurance</em>. Publisher shall maintain during the term and for
            a period of four years following the end of the term of this
            agreement an advertising errors and omissions insurance policy in an
            amount of not less than $1,000,000 dollars per occurrence and
            $2,000,000 annual aggregate. This insurance shall provide coverage
            for any actual or alleged negligent act, error or omission, or
            negligent misstatement or misleading statement by the Publisher in
            the performance or failure to perform lead generation services and
            specifically endorsed to insure the contractual liability assumed in
            this contract. This insurance shall apply to all claims, whether
            instituted by regulatory agencies or private parties.
          </li>
        </ol>
        <H5>5. Confidentiality and Nondisclosure.</H5>
        <ol type="a">
          <li>
            <em>Confidential Information</em>. Publisher recognizes that its
            directors, officers, employees and authorized representatives such
            as attorneys and accountants, may obtain knowledge of Confidential
            Information regardless of whether such information is labeled
            confidential. Accordingly, Publisher agrees to hold such
            Confidential Information (including, but not limited to, this
            Agreement and its contents) in confidence, not to disclose any such
            information to any third party, and to use its reasonable best
            efforts to ensure that such information is held in confidence by its
            officers, directors, employees, representatives and others over whom
            it exercises control and shall not use such information except for
            the performance of its obligations under this Agreement. Publisher
            shall promptly notify ENERGYPAL of any use or disclosure of such
            Confidential Information in violation of this Agreement of which
            Publisher becomes aware.
          </li>
          <li>
            <em>Exceptions</em>. The restrictions set forth in this section
            shall not apply to Confidential Information that (i) was generally
            known or otherwise generally available to the public prior to
            disclosure hereunder, or becomes generally known to the public
            subsequent to such disclosure through no wrongful act or omission of
            the receiving party, (ii) was known to the receiving party at time
            of disclosure, (iii) was received by the receiving party, without
            restriction, from a third party not under an obligation to the
            disclosing party not to disclose it and otherwise not in violation
            of the disclosing party’s rights, (iv) is disclosed pursuant to the
            order or requirement of a court, arbitrator, administrative agency
            or governmental body, or (v) has been specifically identified and
            approved in writing in advance for release by ENERGYPAL.
          </li>
        </ol>
        <H5>6. Representations and Indemnification.</H5>
        <ol type="a">
          <li>
            <em>Mutual Representations</em>. Each party represents and warrants
            to the other party that (1) it has full power, right and authority
            to grant and carry out its respective licenses, rights and
            obligations under this Agreement; (2) the grant and performance of
            such licenses, rights and obligations hereunder (i) will not
            conflict with any charter documents or any agreements, contracts or
            other arrangements to which it is a party, or (ii) will not, to its’
            knowledge, be prohibited or restricted by any government agency; (3)
            a party in the performance of its obligations hereunder, it shall
            not knowingly violate the intellectual property or personal rights
            of any third party; and (4) there is no pending, or to its’
            knowledge, threatened litigation involving such party which would
            have any effect on this Agreement or on its’ ability to perform its
            obligations hereunder.
          </li>
          <li>
            <em>Publisher Representations</em>. Publisher hereby represents and
            warrants that it, or any of its Subcontractors or sales
            representatives, has not been the subject of a complaint, inquiry,
            or investigation, whether brought by a federal, provincial,or state
            regulator, self-regulatory organization such as the Better Business
            Bureaus), private plaintiff, or other third party, arising out of or
            related to Publisher’s, or any of its Subcontractors or sales
            representatives’, compliance with the Consumer Protection Laws
            within the past three (3) years. In the event Publisher or any of
            its Subcontractors or sales representatives are currently or become
            the subject of such complaint, inquiry, or investigation, Publisher
            shall provide ENERGYPAL with copies of all material documentation
            related to such complaint, inquiry, or investigation, including
            documentation sufficient to show and which fully demonstrates the
            steps taken to resolve the complaint, inquiry, or investigation and
            to prevent similar complaints, inquiries, or investigations from
            recurring. This shall be in addition to any other remedy which
            ENERGYPAL may have at law or equity. Publisher further represents
            and warrants that Publisher and any Subcontractors used in
            connection with this Agreement shall accept service of process
            within Canada.
          </li>
          <li>
            <em>Disclaimer of Warranties Regarding ENERGYPAL's Services</em>.
            EXCEPT AS EXPRESSLY SET FORTH HEREIN, ENERGYPAL DISCLAIMS ANY
            WARRANTIES OR REPRESENTATIONS EXPRESS, IMPLIED OR STATUTORY, AND ANY
            WARRANTIES ARISING OUT OF THE COURSE OF DEALING, USAGE, OR TRADE.
            ENERGYPAL DISCLAIMS THAT IT CAN SELL THE CONTRACT LEADS FOR ANY
            PARTICULAR PRICE. THE FOREGOING DISCLAIMERS ARE AN ESSENTIAL PART OF
            THIS AGREEMENT.
          </li>
          <li>
            <em>Indemnification</em>
            <ol>
              <li>
                Publisher and its related and affiliated companies will hold
                harmless, indemnify and defend ENERGYPAL, its affiliates, and
                its other contractors and agents, as well as their directors,
                officers, agents, stockholders, affiliates, and employees of
                each, against all claims, demands, actions, investigations
                (including, without limitation, any government entity or
                governmental inquiry or action), suits, damages, liabilities,
                losses, settlements, and judgments, and will pay all damages and
                costs (including but not limited to reasonable attorneys’ fees
                and costs) arising directly or indirectly out of or resulting
                from: (i) any negligent, reckless, or intentionally wrongful
                acts or omissions on the part of Publisher or its
                Subcontractors; (ii) any alleged or actual breaches of this
                Agreement by Publisher or any of its Subcontractors; (iii) any
                failure of Publisher or its Subcontractors to perform their
                obligations, or their failure to perform its obligations under
                this Agreement in accordance with all applicable Laws, rules and
                regulations, including but not limited to applicable Consumer
                Protection Laws; and (iv) any activities performed by Publisher
                or its Subcontractors in connection with this Agreement, in each
                case whether or not caused by the negligence of ENERGYPAL or any
                other Indemnified Party and whether or not the relevant claim
                has merit. This indemnification obligation shall apply
                regardless of the amount of insurance coverage held by
                ENERGYPAL. ENERGYPAL shall be entitled to offset any amounts
                owed pursuant to this Section from unpaid or future fees payable
                or owed to Publisher.
              </li>
              <li>
                ENERGYPAL hereby agrees to defend and indemnify Publisher
                against, and hold Publisher harmless from any losses, damages,
                liabilities, deficiencies, claims, actions, judgments,
                settlements, interest, awards, penalties, fines, costs, or
                expenses of whatever kind, including court costs and reasonable
                fees of attorneys and other professionals claimed by third
                parties which arise out of or relate to any failure of ENERGYPAL
                to perform a material obligation under this Agreement.
              </li>
              <li>
                If Publisher determines that it is entitled to indemnification
                under this Section 6, Publisher shall promptly notify ENERGYPAL
                in writing of the loss, and provide all reasonably necessary or
                useful information, assistance and authority to settle and/or
                defend any loss. In the event of a loss claimed by a third
                party, the selection of counsel, the conduct of the defense of
                any lawsuit, arbitration, or other proceeding, and any
                settlement shall solely be within ENERGYPAL’s control, provided
                that Publisher shall have the right to participate in the
                defense of such loss using counsel of its choice, at its
                expense. If ENERGYPAL determines that it is entitled to
                indemnification under this Section 6, ENERGYPAL shall promptly
                notify the Publisher in writing of the loss or claim. In the
                event of a loss or claim by a third party, the selection of
                counsel, the conduct of the defense of any lawsuit, arbitration,
                or other proceeding, and any settlement shall solely be within
                the ENERGYPAL’s control, provided that Publisher shall have the
                right to participate in the defense of such claim or loss using
                counsel of its choice, at its expense. Prior to the finalization
                of any settlement or claim, ENERGYPAL shall use reasonable
                efforts to confer with Publisher regarding such settlement.
              </li>
            </ol>
          </li>
        </ol>
        <H5>7. Intellectual Property.</H5>
        <ol type="a">
          <li>
            <em>Trademark Permissions</em>. Publisher grants to ENERGYPAL (and
            any ENERGYPAL affiliates or agents) a limited, fully-paid,
            non-exclusive, non-transferable, non-sublicensable license during
            the term of this Agreement to use Publisher’s trademarks and trade
            names solely in connection with the purposes contemplated by this
            Agreement and contacting the Contract Leads for further
            qualification and/confirmation of Lead Data.
          </li>
          <li>
            <em>Distribution Rights</em>. With respect to the applicable Lead
            Type, Publisher grants ENERGYPAL an exclusive and non-revocable
            right within the Canada, United States, and other service areas to
            offer and sell product and services, distribute, sell, monetize or
            otherwise dispose of (by any means known or hereafter developed),
            sublicense, market and promote, and grant third parties such rights
            regarding the Contract Leads submitted to ENERGYPAL by Publisher
            pursuant to this Agreement. ENERGYPAL, however, shall retain sole
            discretion regarding the methods and manner in which ENERGYPAL offer
            and sell product and services, distributes, sells, monetizes or
            otherwise disposes of, any and all Leads (including, without
            limitation, the Contract Leads) to any current or potential
            customer/client of ENERGYPAL.
          </li>
          <li>
            <em>Contract Lead Ownership</em>. Pursuant to this Agreement, all
            Contract Leads provided under this Agreement shall be deemed to be
            co-owned potential customers of ENERGYPAL and Publisher. Except as
            set forth herein, each party shall have the right to collect and use
            such customer information and interact with such customers
            separately and individually, each (a) in its normal course of
            business and (b) in accordance with (i) the terms of this Agreement,
            (ii) the applicable privacy policies of the parties, and (iii) any
            other applicable laws and regulations. Other than as set forth in
            this Agreement, the parties shall not be responsible for any fees,
            payments, royalties or share of proceeds to the other party as a
            result of such co-ownership or separate use of any Contract Leads
            provided under this Agreement.
          </li>
        </ol>
        <H5>8. Termination of the Agreement.</H5>
        <p>
          This Agreement shall commence when signed by the last of both parties
          and will terminate as provided herein. ENERGYPAL may terminate this
          Agreement at any time and for any reason upon fifteen (15) business
          day’s written notice to the other party. Publisher may terminate this
          Agreement at any time and for any reason upon ninety (90) business
          day’s written notice to the other party. This Agreement shall
          terminate automatically upon six (6) months following the date of last
          delivery of Leads to ENERGYPAL. Except as set forth herein, any
          obligations which expressly or by their nature are to continue after
          termination, cancellation, or expiration of this Agreement shall
          survive and remain in effect after such happening, including without
          limitation, Sections 4, 5, 6, 7(c) and 10.
        </p>
        <H5>Definitions.</H5>
        <p>
          For purposes of this Agreement, the following terms shall be defined
          as follows:
        </p>
        <ol type="a">
          <li>
            "<span className="underline">Agreement</span>" shall collectively
            mean this Publisher Agreement, entered into by ENERGYPAL and
            Publisher, which may be amended from time to time and agreed upon in
            writing.
          </li>
          <li>
            "<span className="underline">Commercial Lead Use</span>" shall mean
            (i) calling, texting, faxing or sending pre-recorded messages using
            manual, computer-assisted or computer automated telephone
            technology, (ii) emailing or (iii) sending direct mail, for purposes
            of offering and selling ENERGYPAL or ENERGYPAL’s client’s products
            and services, as applicable, to any Contract Lead.
          </li>
          <li>
            "<span className="underline">Confidential Information</span>" shall
            mean form posts and associated HTML, trade secrets, form
            functionalities, web technologies, data validation techniques,
            computer information systems, customer lists and names, vendor lists
            and names, product information,pricing information, geographic data,
            any data sourced from the qualification of the Contract Leads, any
            data sourced from the offering and sales of products to the Contract
            Leads, and other confidential information of ENERGYPAL which is
            valuable, proprietary, special or unique to the continued business
            of ENERGYPAL.
          </li>
          <li>
            "<span className="underline">Contract Lead</span>" shall be a Lead
            that has been generated by Publisher and actually submitted to
            ENERGYPAL pursuant to this Agreement.
          </li>
          <li>
            "<span className="underline">Disqualified</span>" are the types of
            Contract Leads that fall outside the parameters set forth in a
            Publisher Agreement and ENERGYPAL systems in which ENERGYPAL shall
            not be required to pay under this Agreement.
          </li>
          <li>
            "<span className="underline">Lead</span>" shall mean a request from
            an individual for information about home energy or improvement
            related products and services, which shall include Lead Data.
          </li>
          <li>
            "<span className="underline">Lead Data</span>" shall mean the
            contact information and other data collected from an individual in
            connection with the generation of a Lead, which shall include name,
            address, phone number and email, and other project criteria
            specified by the form post instructions provided by ENERGYPAL or
            marked as required on the ENERGYPAL provided web form.
          </li>
          <li>
            "<span className="underline">Publisher Account</span>" shall mean
            the information contained within ENERGYPAL systems with regards to
            Publisher company name, contacts, billing information, Contact Lead
            payout amounts and qualification criteria, and associated Contract
            Leads reports, which will be maintained by ENERGYPAL.
          </li>
          <li>
            "<span className="underline">Publisher Materials</span>" shall mean
            any websites and published creatives, including but not limited to,
            marketing/advertising campaign materials, email creatives, banner
            and display advertisements, text and contextual advertisements,
            social media accounts and posts, web widgets and sites, online
            landing pages, collateral, or mailers which are (i) owned and
            operated by Publisher or any Subcontractors and (ii) used to
            generate Leads or Lead Data under this Agreement.
          </li>
          <li>
            "<span className="underline">Restrictions</span>" are prohibited
            forms of advertising or Internet traffic for the generation of
            Contract Leads.
          </li>
        </ol>
        <H5>10. Miscellaneous Terms.</H5>
        <ol type="a">
          <li>
            <em>Independent Contractor</em> . The relationship between ENERGYPAL
            and Publisher established by this Agreement is that of independent
            contractor and no other relationship is intended, including a
            partnership, franchise, joint venture, agency, employer/employee,
            fiduciary, master/servant relationship, or other special
            relationship. For the avoidance of doubt, Publisher shall not be
            deemed to be advertising on behalf of ENERGYPAL in connection with
            the generation of any Leads. Publisher is an independent contractor
            providing Leads to ENERGYPAL in compliance with applicable U.S. law
            and no other relationship is intended. Publisher shall not (i) use
            any ENERGYPAL trade name or brand (including, without limitation,
            “EnergyPal” and “EnergyGeeks””) without prior express written
            consent of ENERGYPAL or (ii) represent in any way that their company
            or brand is associated with or sponsored in any way by ENERGYPAL.
          </li>
          <li>
            <em>Affiliates & Subcontractors</em>. As between ENERGYPAL and
            Publisher, Publisher shall remain solely liable for all actions and
            omissions resulting from Publisher’s agents, affiliates, third party
            marketing partners/vendors, affiliate networks, and or third
            party/affiliate call centers (collectively, "Subcontractors") used
            under this Agreement. All Subcontractors must be provided a copy of
            the Publisher Agreement and the T&Cs, and shall be bound by the
            terms of the Publisher Agreement and T&Cs.
          </li>
          <li>
            <em>Licenses</em>. Nothing in this Agreement is intended to grant
            any rights to Publisher under any patent, mask work right,
            copyright, trade secret or other intellectual property right of
            ENERGYPAL, nor shall this Agreement grant Publisher any rights in or
            to the Confidential Information of ENERGYPAL except as expressly set
            forth herein.
          </li>
          <li>
            <em>Notices</em>. Any notice required or permitted by this Agreement
            shall be in writing and shall be delivered as follows with notice
            deemed given as indicated: (a) by personal delivery when delivered
            personally; (b) by overnight courier upon written verification of
            receipt; (c) by telecopy or facsimile transmission upon
            acknowledgment of receipt of electronic transmission; or (d) by
            certified or registered mail, return receipt requested, upon
            verification of receipt. All notices shall be sent to the parties at
            the following addresses: (i) to Publisher at the address provided
            during registration; and (ii) to ENERGYPAL, Attn: Legal, EnergyPal,
            8005 Financial Dr, Suite 323, Brampton, On, Canada L6Y6A1.
          </li>
          <li>
            <em>Governing Law</em>. This Agreement, all claims or causes of
            action (whether in contract or tort) that may be based upon or arise
            out of or relate to this Agreement or relate to the negotiation,
            execution or performance of the Agreement (including an
            representation or warranty made in connection with this Agreement),
            and any services provided hereunder shall be governed by, construed
            and interpreted in accordance with the laws of Ontario, Canada,
            without regard to the conflict of laws provisions thereof to the
            extent such principles or rules would require or permit the
            application of the laws of any jurisdiction other than those of
            Ontario, Canada. This Agreement shall be deemed to have been entered
            into and performed in Canada.
          </li>
          <li>
            <em>Dispute Resolution; Arbitration.</em>
            <ol>
              <li>
                Mandatory Arbitration. In the event of any dispute whatsoever
                between the parties, including but not limited to any disputes
                concerning interpretation, enforcement or application of this
                Agreement or any Publisher Agreement, including fraud in the
                inducement, such disputes shall be exclusively resolved by final
                and binding arbitration before one arbitrator, who shall be a
                retired judge, administered by the American Arbitration
                Association in accordance with its Commercial Arbitration Rules.
                Judgment on the arbitration award may be entered in any court
                having jurisdiction thereof. The arbitration shall be held in
                San Francisco. The parties jointly request that the appointed
                arbitrator administer the arbitration efficiently and, if
                possible, issue a decision within six (6) months from the date
                the arbitrator is appointed. The arbitrator’s award shall be
                final and binding, and shall set forth both the legal and
                factual basis of the award.
              </li>
              <li>
                Attorneys Fees. The prevailing party in any arbitration or other
                legal proceeding seeking injunctive or legal relief, shall
                receive an award for its attorney’s fees, expert fees, costs,
                and expenses.
              </li>
              <li>
                Equitable Claims. Notwithstanding the arbitration provision, the
                Parties hereto reserve the right to obtain injunctive or other
                equitable relief in a court of law. The Parties hereto consent
                that proper venue to obtain injunctive or other equitable relief
                shall be provincialor federal court in Ontario, Canada.
              </li>
              <li>
                Choice of Law Under Arbitration. All claims and causes of action
                (whether in contract or tort) shall be governed by, construed
                and interpreted in accordance with the laws of the Ontario,
                Canada, without regard to principles of conflict of laws.
              </li>
            </ol>
          </li>
          <li>
            <em>No Third Party Beneficiaries</em>. Only the parties hereto are
            entitled to enforce the provisions of this Agreement and no third
            party beneficiary is intended under this Agreement.
          </li>
          <li>
            <em>Limitation of Liability</em>. EXCEPT IN CONNECTION WITH AN
            OBLIGATION OF INDEMNIFICATION (SECTION 6) OR A BREACH OF
            CONFIDENTIALITY (SECTION 5) AND TO THE FULLEST EXTENT PERMITTED BY
            LAW, (A) IN NO EVENT WILL EITHER PARTY BE LIABLE TO THE OTHER PARTY
            FOR ANY SPECIAL, PUNITIVE, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL
            DAMAGES (INCLUDING, WITHOUT LIMITATION, LOSS OF USE, DATA, BUSINESS
            OR LOST PROFITS) ARISING OUT OF OR IN CONNECTION WITH THIS
            AGREEMENT, WHETHER SUCH LIABILITY ARISES FROM ANY CLAIM BASED UPON
            CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY
            OR OTHERWISE AND EVEN IF EITHER PARTY IS ADVISED OF THE POSSIBILITY
            OF SUCH DAMAGES AND EVEN IF THE DAMAGES WERE FORESEEABLE; AND (B)
            EACH PARTIES’ CUMULATIVE LIABILITY FROM ALL CAUSES OF ACTION AND ALL
            THEORIES OF LIABILITY TO THE OTHER PARTY WILL BE LIMITED TO AND WILL
            NOT EXCEED THE AMOUNTS PAID OR PAYABLE UNDER THIS AGREEMENT DURING
            THE SIX (6) MONTH PERIOD PRECEDING THE CLAIM GIVING RISE TO ANY SUCH
            LIABILITY.
          </li>
          <li>
            <em>Construction</em>. ENERGYPAL and Publisher acknowledge and agree
            that this Agreement is the product of arms-length negotiations
            between ENERGYPAL and Publisher, both of whom are sophisticated
            commercial parties of equal bargaining power, and that neither party
            has in any manner relied on the other party’s expertise and/or
            superior knowledge, if any, in entering into this Agreement.
            ENERGYPAL and Publisher acknowledge and agree that this Agreement
            shall be construed as if jointly prepared and drafted by both
            parties and that under no circumstances will any provision hereof be
            construed for or against either party due to that party’s actual
            role in the preparation or drafting of this Agreement. Each party
            acknowledges that the provisions of this Agreement were negotiated
            to reflect an informed, voluntary allocation between them of all the
            risks (both known and unknown) associated with the transactions
            contemplated hereunder.
          </li>
          <li>
            <em>Entire Agreement</em>. The Publisher Agreement and the T&Cs
            together contain the entire agreement between the parties and
            supersedes all previous agreements and proposals, oral or written,
            and all negotiations, representations, warranties, conversations, or
            discussions between the parties related to the subjects hereof.
            Publisher acknowledges it has not relied on any representations or
            statements by ENERGYPAL not included in this written Agreement. The
            parties hereto have voluntarily agreed to define their rights,
            liabilities and obligations respecting the subject hereof
            exclusively in contract pursuant to the express terms and provisions
            of this Agreement and the parties hereto expressly disclaim that
            they are entitled to any remedies not expressly set forth in this
            Agreement.
          </li>
          <li>
            <em>Amendment</em>. The Publisher Agreement may only be amended in a
            writing signed by or consented to by both parties (which may
            include, without limitation, email). The T&Cs may only be amended in
            a writing signed by both parties. All such revisions will be deemed
            to be a part of and incorporated into the agreement between the
            parties related to the subjects hereof.
          </li>
          <li>
            <em>Conflict</em>. Each executed Publisher Agreement shall
            incorporate the T&Cs. In the event of a conflict between the
            Publisher Agreement (including any subsequent written modifications)
            and the T&Cs, the terms of the T&Cs shall govern. A Publisher
            Agreement (including any subsequent written modifications) shall
            take precedence over the T&Cs ONLY where the Publisher Agreement
            (revised or otherwise) (i) specifically references the T&C section
            to be modified and (ii) is signed by ENERGYPAL.
          </li>
          <li>
            <em>Severability</em>. If any term or provision is held to be
            unenforceable or invalid to any extent, the remainder of this
            Agreement shall not be affected and each other term or provision of
            this Agreement shall be valid to the fullest extent permitted by
            law.
          </li>
          <li>
            <em>Waiver</em>. The failure of any party hereunder to insist upon
            strict performance of any terms or provisions of this Agreement
            shall not be construed as a waiver or relinquishment for the future
            of any such terms or provisions. Rather such terms and provisions
            shall continue and remain in full force and effect. No waiver shall
            be deemed to have been made unless the waiver is made in writing and
            signed by the party making the waiver.
          </li>
          <li>
            <em>Assignment</em>. Neither party may assign any of its rights or
            obligations under a Publisher Agreement or these T&Cs without the
            express prior written consent of the other party, except pursuant to
            a merger, consolidation or sale of all or substantially all of such
            party’s assets, provided that the surviving or transferee entity in
            such merger, consolidation or sale assumes all of such party’s
            obligations hereunder and explicitly agrees to be bound by the terms
            herein.
          </li>
          <li>
            <em>Force Majeure</em>. Each party shall be excused from performance
            and shall not be considered to be in default with respect to any
            obligation hereunder, if and to the extent that such failure or
            delay is due to causes beyond its reasonable control, including but
            not limited to acts of God, war, strikes or labor disputes,
            embargoes, government orders or any other force majeure event.
          </li>
        </ol>
        <p>Last Updated: October 17, 2022</p>
      </CenteredContentSection>
    </article>
  );
}
